import { aiInRecruitingUseCasesSectionData } from 'constants/AiInRecruiting'
import styles from './AiInRecruitingUseCasesSection.module.css'

const CheckIcon = () => (
  <svg
    width="21"
    height="12"
    viewBox="0 0 21 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 5.77344L11 -6.53267e-05V11.5469L21 5.77344ZM0 5.77344V6.77344H12V5.77344V4.77344H0V5.77344Z"
      fill="#0010F1"
    />
  </svg>
)

const AiInRecruitingUseCasesSection = () => {
  const { title, subtitle, items } = aiInRecruitingUseCasesSectionData

  return (
    <section className={styles.useCasesSection}>
      <div className="container">
        <div className={`row align-items-center ${styles.header}`}>
          <h2 className={styles.sectionTitle}>{title}</h2>
          <p className={styles.sectionSubtitle}>{subtitle}</p>
        </div>
        <div>
          {items.map((item, i) => (
            <div key={i}>
              <div className={styles.card}>
                <CheckIcon />
                <h3 className={styles.cardTitle}>{item.title}</h3>
                <p className={styles.cardDesc}>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default AiInRecruitingUseCasesSection
